var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppIcon(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 60,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M25.9 2.61H7.137C4.61 2.61 2.54 4.677 2.54 7.204v45.56c0 2.527 2.07 4.595 4.597 4.595H25.9c2.528 0 4.596-2.07 4.596-4.6V7.2A4.608 4.608 0 0025.9 2.607zM14.65 6.712h3.735a.67.67 0 010 1.34H14.65a.673.673 0 01-.67-.67c0-.37.303-.67.67-.67zm1.87 48.398a2.538 2.538 0 112.54-2.538 2.53 2.53 0 01-2.53 2.537z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M4.715 11.525h23.44V48.29H4.715z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    stroke: "#333",
    strokeWidth: 0.3,
    d: "M16.418 39.106v-.125.13h.125-.125zM9.98 34.78h6.313v4.2H9.98v-4.2zm13.378 4.326v-.125.13h.125-.125zM16.92 34.78h6.313v4.2H16.92v-4.2zm-6.94-9.63h8.223L9.98 33.7v-8.55zm13.378 9.128v-.125.125h.125-.125zm-12.943-.125L23.233 20.82v13.333H10.415zM9.98 20.347h12.84l-4.015 4.175H9.98v-4.175zm13.88-.627H9.354v.125h.124-.124v19.763H23.86V19.72z"
  }))));
}
export default SvgAppIcon;